"use strict";
import { CONNECTION } from "components/Web3Provider/constants";
import forkConfig from "forkConfig";
import { useAccount } from "hooks/useAccount";
export function useIsUniExtensionAvailable() {
  const currentConnector = useAccount().connector;
  const currentConnectIsNotUniExtension = currentConnector && currentConnector.id !== CONNECTION.UNISWAP_EXTENSION_RDNS;
  return !currentConnectIsNotUniExtension && forkConfig.uniSpecificFeaturesEnabled;
}
